module.exports = __webpack_public_path__ + "media/images/athletes/516-95f83b1b2eba1b8ac818b09cd01d2347.png";